import { Box, Typography } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { resolveCurrentSiteId } from "../hooks/useLastSelectedSite";

import { isDemoRoles } from "@/utils/demoMode";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    const isAuthenticated = context.auth?.isAuthenticated;
    const sites = context.auth?.sites ?? [];

    if (!isAuthenticated) {
      throw redirect({ to: "/login" });
    }

    const targetSiteId = resolveCurrentSiteId(sites);

    if (targetSiteId) {
      throw redirect({
        to: "/dragon-tiles/$siteId",
        params: { siteId: targetSiteId },
      });
    }

    // Agency users don't own sites; route them to Besties under their org_id.
    // Demo accounts are excluded: Besties is off-limits to them, so this
    // redirect would loop with the demo route guard (FOG-2234).
    const user = context.auth?.user;
    if (
      user?.org_type === "agency" &&
      user.org_id &&
      !isDemoRoles(user.roles)
    ) {
      throw redirect({
        to: "/besties/$siteId",
        params: { siteId: user.org_id },
      });
    }
    // If no sites, do not redirect
    return;
  },
  component: NoSitesComponent,
});

function NoSitesComponent() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
      }}
    >
      <Typography variant="h5" gutterBottom>
        No Sites Available
      </Typography>
      <Typography variant="body1">
        Your account does not have any sites assigned. Please contact support or
        your administrator.
      </Typography>
    </Box>
  );
}
